import React from 'react';

import iconCubierta from "../../assets/svgs/Cubierta.svg";
import iconFachada from "../../assets/svgs/Fachada.svg";
import { ProductData } from "../../data/product.data"
import { ColorData } from "../../data/color.data"
import useScreenOrientation from '../helpers/useScreenOrientation';

import icon3D from "../../assets/svgs/Icon_3D.svg";
import iconGallery from "../../assets/svgs/Icon_Gallery.svg";

export default function ProductSelection({  roofProduct, setRoofProduct, roofColor, setRoofColor, 
                                            facadeProduct, setFacadeProduct, facadeColor, setFacadeColor,
                                            scenario, setScenario, productCategory, setProductCategory,
                                            setMenuView}: any) {

  const isLandscape = useScreenOrientation();

  const [roofList, setRoofList] = React.useState([]);
  const [roofCount, setRoofCount] = React.useState(0);
  const [roofColorList, setRoofColorList] = React.useState<any>([]);

  const [facadeList, setFacadeList] = React.useState([]);
  const [facadeCount, setFacadeCount] = React.useState(0);
  const [facadeColorList, setFacadeColorList] = React.useState<any>([]);

  const [showTooltip, setShowTooltip] = React.useState(false);

  React.useEffect(() => {
    //setProductCategory("roof")
    if (scenario) {
      var roof_count = 0
      var roof_list: any = [];
      var facade_count = 0;
      var facade_list: any = [];
      var roofProducts: any = ProductData()
      var facadeProducts: any = ProductData()

      for (let product of roofProducts) {
        if (product.active === true){ //&& scenario.productsRoof.includes(product.id))
          product.available = scenario.productsRoof.includes(product.id)
          roof_count = roof_count + product.available ? 1 : 0
          roof_list.push(product)
        }
      }

      for (let product of facadeProducts) {
        if (product.active === true){
          product.available = scenario.productsFacade.includes(product.id) //&& scenario.productsFacade.includes(product.id))
          facade_count = facade_count + product.available ? 1 : 0
          facade_list.push(product)
        }
      }
      setRoofCount(roof_count);
      setFacadeCount(facade_count);
      setRoofList(roof_list);
      setFacadeList(facade_list);

    }
  }, [scenario, setProductCategory]);

  React.useEffect(() => {
    if(roofProduct){
      let colorData: any = ColorData()
      let colors = colorData[roofProduct.id] 
      if(colors){
        let color_list: any = [];
        for (let color of colors) {
          if (color.active)
            color_list.push(color)
        }

        const remaining = color_list.length % 7;
        if(remaining !== 0){
          const missing = 7 - remaining
          for (let m = 0; m < missing; m++) {
            let color = { "id": "", "name" : "", "description" : "",
              "icon": require('../../assets/colors/Disabled.webp'),
              "interactable" : false
            }
            color_list.push(color)
          }
        }
        setRoofColorList(color_list)
      }
    }
    if(facadeProduct){
      let colorData: any = ColorData()
      let colors = colorData[facadeProduct.id] 
      if(colors){
        let color_list: any = [];
        for (let color of colors) {
          if (color.active)
            color_list.push(color)
        }

        const remaining = color_list.length % 7;
        if(remaining !== 0){
          const missing = 7 - remaining
          for (let m = 0; m < missing; m++) {
            var color = { "id": "", "name" : "", "description" : "",
              "icon": require('../../assets/colors/Disabled.webp'),
              "interactable" : false
            }
            color_list.push(color)
          }
        }
        setFacadeColorList(color_list)
      }
    }
  }, [roofProduct, facadeProduct]);

  const SetRoofCategory = () => {
    setProductCategory("roof")
  }
  const SetFacadeCategory = () => {
    setProductCategory("facade")
  }

  const ShowToolTipTemporary = () => {
    setShowTooltip(true)
    setTimeout(()=> setShowTooltip(false), 3000)
  }

  return (
    <div className="product-selector-container">
      <div className="product-selector-background">
        <div className="product-selector-content">

          {/* CATEGORIES */}
          <div className="product-selector-category">
            <div className={`product-selector-category-button ${roofCount > 0 ? '' : 'disabled'} ${productCategory === "roof" ? 'selected' : ''}`} onClick={() => SetRoofCategory()}>
              <img className={`product-selector-category-button-icon`} src={iconCubierta} alt='' />
              <div className={`product-selector-category-button-text ${roofCount > 0 ? '' : 'disabled'}`}>
                CUBIERTA
              </div>
            </div>
            <div className={`product-selector-category-button ${facadeCount > 0 ? '' : 'disabled'} ${productCategory === "facade" ? 'selected' : ''}`} onClick={() => SetFacadeCategory()}>
              <img className={`product-selector-category-button-icon`} src={iconFachada} alt='' />
              <div className={`product-selector-category-button-text ${facadeCount > 0 ? '' : 'disabled'}`}>
                FACHADA
              </div>
            </div>
          </div>
          <div className="product-selector-title-underline"/>

          {/* PRODUCTS */}
          <div className={`${isLandscape ? 'product-list-disordered' : 'product-list-scroller'}`}>
            { productCategory === 'roof' ? 
              roofList.map((productIter: any, index) =>
                <div key={index} className={`product-list-button ${isLandscape ? '' : 'portrait'} ${productIter.id === roofProduct.id ? 'selected' : ''} ${productIter.available === true &&  productIter.interactable === true ? '' : 'disabled'}`} onClick={() => setRoofProduct(productIter)}>
                  <div className={`product-list-button-text ${productIter.available === true &&  productIter.interactable === true ? '' : 'disabled'}`}>
                    {productIter.name}
                  </div>
                </div>
              )
              :
              facadeList.map((productIter: any, index) =>
                <div key={index} className={`product-list-button ${isLandscape ? '' : 'portrait'} ${productIter.id === facadeProduct.id ? 'selected' : ''} ${productIter.available === true &&  productIter.interactable === true ? '' : 'disabled'}`} onClick={() => setFacadeProduct(productIter)}>
                  <div className={`product-list-button-text ${productIter.available === true &&  productIter.interactable === true ? '' : 'disabled'}`}>
                    {productIter.name}
                  </div>
                </div>
              )
            }
          </div>

          {/* COLORS */}
          <div className={`product-color-selector-container ${ isLandscape ? '' : 'portrait'}`}>

              <div className={`product-color-selector-tooltip ${ showTooltip ? '' : 'hidden'}`}><i>*Colores de Referencia. Solicite muestra física*</i></div>
              <div className="product-color-selector-title">COLOR<div className="product-color-selector-help" onClick={() => ShowToolTipTemporary()} onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>Nota!</div></div>
              
              <div className={`${ isLandscape ? 'product-color-list-container' : 'product-color-list-scroller'}`}>
                { productCategory === 'roof' ? 
                  (roofColorList as {}[]).map((color: any, index) =>
                    (isLandscape === true ||  color.interactable === true)  && <img key={index} className={`product-color-list-button ${color.interactable === true ? '' : 'disabled'}`} src={color.icon} onClick={() => {if(color.interactable === true){setRoofColor(color)} }} alt='' />
                  )
                :
                  (facadeColorList as {}[]).map((color: any, index) =>
                    (isLandscape === true ||  color.interactable === true)  && <img key={index} className={`product-color-list-button ${color.interactable === true ? '' : 'disabled'}`} src={color.icon} onClick={() => {if(color.interactable === true){setFacadeColor(color)} }} alt='' />
                  )
                }
              </div>

              <div className={`product-color-selected-data ${ isLandscape ? '' : 'row'}`}>
                <div className={`product-color-selected-name ${ isLandscape ? '' : 'portrait'}`}>
                  { productCategory === 'roof' ?
                    roofColor !== null ? roofColor.name : ""
                  :
                    facadeColor !== null ? facadeColor.name : ""
                  }
                </div>
                <div className="product-color-selected-info">
                  { productCategory === 'roof' ?
                    roofColor !== null ? roofColor.description : ""
                  :
                    facadeColor !== null ? facadeColor.description : ""
                  }
                </div>
              </div>
          </div>

          {/* INFO */}
          <div className={`product-info-selector-container ${ isLandscape ? '' : 'portrait'}`} >
            <div className={`product-info-button`} onClick={() => setMenuView("VISTA 3D")}>
              <img className={`product-info-button-icon`} src={icon3D} alt=''/>
              <div className="product-info-button-text">
                Producto 3D
              </div>
            </div>
            <div className={`product-info-button`} onClick={() => setMenuView("GALERÍA")}>
              <img className={`product-info-button-icon`} src={iconGallery} alt=''/>
              <div className="product-info-button-text">
                Ver galería
              </div>
            </div>
          </div>

          {/* <div className={`product-info-selector-container ${ isLandscape ? '' : 'portrait'}`} >
            { productCategory === 'roof' &&
              <div className={`product-info-button`} onClick={() => setMenuView("VISTA 3D")}>
                <img className={`product-info-button-icon`} src={icon3D} alt=''/>
                <div className="product-info-button-text">
                  Producto 3D
                </div>
              </div>
            }
            <div className={`product-info-button ${productCategory === 'roof' ? '' : 'full'}`} onClick={() => setMenuView("GALERÍA")}>
              <img className={`product-info-button-icon`} src={iconGallery} alt=''/>
              <div className="product-info-button-text">
                Ver galería
              </div>
            </div>
          </div> */}

        </div>
      </div>
    </div>
  );
}
